import { render, staticRenderFns } from "./input-token.vue?vue&type=template&id=67a455a6&"
import script from "./input-token.vue?vue&type=script&lang=js&"
export * from "./input-token.vue?vue&type=script&lang=js&"
import style0 from "./input-token.vue?vue&type=style&index=0&id=67a455a6&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports